export default "__VITE_ASSET__D$bqtgMA__"